

module.exports = __webpack_require__.stylable.create(
    "BookButton3400822065",
    {"classes":{"root":"BookButton3400822065__root"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    8,
    "BookButton3400822065",
    null
);
